import React from 'react';
import { motion } from 'framer-motion';
import './FeaturesSection.css';

const FeaturesSection = () => {
  const features = [
    {
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M12 2v20M2 12h20" strokeLinecap="round" strokeLinejoin="round"/>
          <circle cx="12" cy="12" r="10"/>
        </svg>
      ),
      title: '₹1 Downpayment',
      description: 'Start your solar journey with just ₹1. No large upfront investment needed. We make solar accessible for everyone.'
    },
    {
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M20 7h-4V3H8v4H4v10h16V7z"/>
          <path d="M8 3v4M16 3v4M4 7h16"/>
        </svg>
      ),
      title: 'Up to ₹78,000 Subsidy',
      description: 'Get government subsidy directly credited to your bank account. We handle all the paperwork and approvals.'
    },
    {
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      ),
      title: 'EMI < Your Bill',
      description: 'Your monthly EMI will be less than your current electricity bill. Start saving from day one!'
    },
    {
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      ),
      title: '25-Year Warranty',
      description: 'Industry-leading warranty on solar panels. Premium quality components with guaranteed performance.'
    },
    {
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/>
          <path d="M14 2v6h6M16 13H8M16 17H8M10 9H8"/>
        </svg>
      ),
      title: 'Zero Paperwork Hassle',
      description: 'We handle all documentation, permissions, and subsidy applications. You just sit back and relax.'
    },
    {
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <circle cx="12" cy="12" r="10"/>
          <path d="M12 6v6l4 2" strokeLinecap="round"/>
        </svg>
      ),
      title: 'Quick Installation',
      description: 'Professional installation in 3-5 days. Minimal disruption to your daily routine. Same-day activation.'
    }
  ];

  return (
    <section id="features" className="features-section">
      <div className="features-container">
        <motion.div
          className="section-header"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h2 className="section-title-main">Why Choose Adityam Urja?</h2>
          <p className="section-description">
            We've made solar simple, affordable, and accessible. Here's what makes us different.
          </p>
        </motion.div>

        <div className="features-grid">
          {features.map((feature, index) => (
            <motion.div
              key={index}
              className="feature-card"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              whileHover={{ y: -8 }}
            >
              <div className="feature-icon-wrapper">
                {feature.icon}
              </div>
              <h3 className="feature-title">{feature.title}</h3>
              <p className="feature-description">{feature.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;

